import React, { useContext, useState, useEffect, useRef } from "react";
import { SearchContext } from "./SearchContext";
import { FaChevronDown } from "react-icons/fa6";

const ServiceList = () => {
  const { serviceList, service, city, state, lat, lng, zip, radius } = useContext(SearchContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // 1. Identify the current service by ID (matching string->number)
  const currentServiceObj = serviceList.find(item => String(item.id) === String(service));

  // 2. Filter out that service from the list
  const filteredServices = serviceList.filter(item => String(item.id) !== String(service));

  // Toggle the dropdown
  const toggleDropdown = () => setShowDropdown(prev => !prev);

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex justify-between md:justify-center lg:justify-start w-full print:hidden">
      {/* Left Section: show the current service name if we have it */}
      <div className="lg:mr-2 text-lg text-white bg-primaryBlue rounded-md py-1 px-2 col-span-2 lg:col-span-1 text-center lg:text-left">{currentServiceObj ? currentServiceObj.name : "Service Name"}</div>

      {/* Right Section */}
      <div className="mt-2 lg:mt-0 relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={toggleDropdown}
          className="text-primaryBlue bg-grey-200 underline underline-offset-2
                     focus:ring-4 font-medium rounded-lg text-xs lg:text-sm 
                     px-1 lg:px-2 py-1 lg:py-2 text-center inline-flex items-center 
                     dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Change Service / Care
          <FaChevronDown className="ml-2" />
        </button>

        {/* Dropdown Popup */}
        {showDropdown && (
          <div
            className="absolute left-0 top-full z-10 
                       py-2 text-sm text-gray-700 dark:text-gray-200
                       bg-white shadow-lg rounded-md mt-1 w-[300px]"
          >
            {filteredServices.map(item => {
              // Build the link for each service, adding city/state/lat/lng/zip/radius
              // plus services[]=... for the new service ID
              const serviceLink = `/cjsearch/?search_area=${encodeURIComponent(`${city}, ${state}`)}` + `&lat=${lat}` + `&lng=${lng}` + `&city=${city}` + `&state=${state}` + `&zip=${zip || ""}` + `&provider_name=` + `&support=` + `&services%5B%5D=${item.id}` + `&radius=${radius || "25"}`;

              return (
                <a
                  key={item.id}
                  href={serviceLink}
                  className="block px-4 py-2 hover:bg-gray-100 
                             dark:hover:bg-gray-600 cursor-pointer 
                             text-primaryBlue"
                >
                  <i className={`${item.icon} mr-2`} />
                  {item.name}
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceList;
